/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：266
 */

module.exports = {
  dialog: "ConfirmDialog_dialog__yHS01",
  dialogButtons: "ConfirmDialog_dialogButtons__nS63H",
  dialogSecondary: "ConfirmDialog_dialogSecondary__50hKJ",
  denyButton: "ConfirmDialog_denyButton__1yfVU"
}
